import styled from "styled-components";

export const Wrapper = styled.div`
    height: 75px;
    width: 100%;
    background-color: #0BB089;
`;
